import { css } from '@emotion/react';
import cns from 'classnames';
import { Icon } from '../Icon';
import { Button, ButtonProps } from '../Button/Button';
import styled from '@emotion/styled';
import { space, SpaceProps } from 'styled-system';
import { FC } from 'react';

export const MODAL_CLOSE_CLASSNAME = '__mapui_modalCloseButton';

export type ModalCloseButtonProps = ButtonProps & SpaceProps;

const applyMainStyles = (theme) => css(theme.modal.closeButton);

const ModalCloseButtonContainer = styled(Button)<ModalCloseButtonProps>(
  ({ theme }) => ({
    ...applyMainStyles(theme),
  }),
  ({ className }) => ({
    className: cns(MODAL_CLOSE_CLASSNAME, className),
  }),
  space
);

export const ModalCloseButton: FC<ModalCloseButtonProps> = ({
  children,
  ...rest
}: ModalCloseButtonProps) => (
  <ModalCloseButtonContainer {...rest} variant="secondary" size="xs">
    <Icon icon="times" />
  </ModalCloseButtonContainer>
);
